import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthInterceptor } from './auth.interceptor';
import { CredentialsInterceptor } from './credentials.interceptor';
import { MockInterceptorModule } from './mock-interceptor.module';

@NgModule({
  declarations: [],
  imports: [MockInterceptorModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: CredentialsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
})
export class InterceptorsModule {}
